import { render, Suspense } from "@wordpress/element";
import withAppProviders from "withAppProviders";
import Block from "./Block";

const AllWineClubsFrontend = ({ attributes }) => {
	return <Block attributes={attributes} />;
};

const AllWineClubs = withAppProviders(AllWineClubsFrontend)();
export default AllWineClubs;

window.addEventListener("DOMContentLoaded", () => {
	const element = document.querySelector(".wp-block-vino-wine-clubs");
	if (element) {
		render(
			<Suspense fallback={<div className="wp-block-placeholder" />}>
				<AllWineClubs />
			</Suspense>,
			element
		);
	}
});
